var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit } from '@angular/core';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { Store, Select } from '@ngxs/store';
import { RemoveChapter, TakeChapterPicture, DuplicateChapter, RecordChapterCamera } from 'src/app/story/state/chapters/story.chapters.actions';
import { MatSnackBar, MatDialog } from '@angular/material';
import { CameraService } from 'src/app/engine/camera.service';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable } from 'rxjs';
import { ContentDialogComponent } from '../content-dialog/content-dialog.component';
import { DialogService } from 'src/app/dialogs/dialog.service';
var ChapterActionsComponent = /** @class */ (function () {
    function ChapterActionsComponent(store, snackbar, dialog, cameraService, dialogService) {
        this.store = store;
        this.snackbar = snackbar;
        this.dialog = dialog;
        this.cameraService = cameraService;
        this.dialogService = dialogService;
        this.selected = false;
    }
    ChapterActionsComponent.prototype.ngOnInit = function () {
    };
    ChapterActionsComponent.prototype.handleCaptureClick = function () {
        this.capturePosition();
        this.captureThumbnail();
        this.snackbar.open('Successfully captured chapter starting position and thumbnail.');
    };
    ChapterActionsComponent.prototype.handleCapturePositionClick = function () {
        this.capturePosition();
        this.snackbar.open('Successfully captured chapter starting position.');
    };
    ChapterActionsComponent.prototype.handleCaptureThumbnailClick = function () {
        this.captureThumbnail();
        this.snackbar.open('Successfully captured chapter thumbnail.');
    };
    ChapterActionsComponent.prototype.handleDuplicateClick = function () {
        this.duplicateChapter();
    };
    ChapterActionsComponent.prototype.handleRemoveClick = function () {
        this.removeChapter();
    };
    ChapterActionsComponent.prototype.handleContentClick = function () {
        this.openChapterContentDialog(this.chapter.id);
    };
    ChapterActionsComponent.prototype.handleBackgroundColorClick = function () {
        this.dialogService.openBackgroundColorDialog();
    };
    ChapterActionsComponent.prototype.duplicateChapter = function () {
        this.store.dispatch(new DuplicateChapter(this.chapter));
        this.snackbar.open("Duplicated chapter \"" + this.chapter.info.displayName + "\"");
    };
    ChapterActionsComponent.prototype.removeChapter = function () {
        var _this = this;
        var dialogRef = this.dialogService.openConfirmDialog({
            data: {
                titleText: 'Remove chapter',
                bodyText: 'This cannot be undone.',
                confirmText: 'Remove',
                confirmColor: 'warn'
            }
        });
        dialogRef.afterClosed().subscribe(function (confirmed) {
            if (confirmed) {
                _this.store.dispatch(new RemoveChapter(_this.chapter));
                _this.snackbar.open("\"" + _this.chapter.info.displayName + "\" chapter has been removed");
            }
        });
    };
    ChapterActionsComponent.prototype.captureThumbnail = function () {
        this.store.dispatch(new TakeChapterPicture(this.chapter.id));
    };
    ChapterActionsComponent.prototype.capturePosition = function () {
        var camera = this.cameraService.getCamera();
        this.store.dispatch(new RecordChapterCamera(camera, true));
    };
    ChapterActionsComponent.prototype.openChapterContentDialog = function (chapterId) {
        this.dialog.open(ContentDialogComponent, {
            width: '60vw',
            height: 'auto',
            data: {
                chapterId: chapterId
            }
        });
    };
    __decorate([
        Select(StoryChaptersState.getStoryChapters),
        __metadata("design:type", Observable)
    ], ChapterActionsComponent.prototype, "chapters$", void 0);
    __decorate([
        Select(StoryChaptersState.getRegisteredThumbnails),
        __metadata("design:type", Observable)
    ], ChapterActionsComponent.prototype, "thumbnails$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterBackground),
        __metadata("design:type", Observable)
    ], ChapterActionsComponent.prototype, "background$", void 0);
    return ChapterActionsComponent;
}());
export { ChapterActionsComponent };
